import { FeatureType } from "interfaces/feature-tracker";
import { baseApi } from "../api";

const featureType = FeatureType.BUNDLE_UP;

export const bundleUpAPI = baseApi.injectEndpoints({
	endpoints: (builder) => ({
		UpdateCooldown: builder.mutation({
			query: (arg) => {
				const queryParams = new URLSearchParams();
				for (const key in arg) {
					queryParams.append(key, arg[key]);
				}
				return {
					url: `/rest/${featureType}/start-cooldown?${queryParams.toString()}`,
					method: "POST"
				};
			}
		})
	})
});

export const { useUpdateCooldownMutation } = bundleUpAPI;
